import { useState, useEffect } from 'react';

/**
 * Хук для управления анимацией загрузки.
 * 
 * @param {boolean} isDataLoaded - Флаг, загрузились ли реальные данные
 * @param {Function} [onComplete] - Колбэк, вызываемый по завершении анимации и загрузки
 * @returns {Object} Состояние анимации { isReady, loadingProgress, showLogo }
 */
export function useLoadingAnimation(isDataLoaded, onComplete) {
    const [isReady, setIsReady] = useState(false);
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [showLogo, setShowLogo] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setLoadingProgress(prev => {
                if (!isDataLoaded && prev >= 85) {
                    return prev + (90 - prev) * 0.05;
                }
                if (prev >= 99) {
                    setIsReady(true);
                    clearInterval(interval);
                    setTimeout(() => {
                        setShowLogo(true);
                        setTimeout(() => {
                            if (onComplete) {
                                onComplete();
                            }
                        }, 1000);
                    }, 500);

                    return 100;
                }
                return prev + Math.random() * 15;
            });
        }, 200);

        return () => clearInterval(interval);
    }, [isDataLoaded, onComplete]);

    return {
        isReady,
        loadingProgress,
        showLogo
    };
}
